(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ath-featured-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.athReady) return;
    root.dataset.athReady = 'true';
    const select = root.querySelector('[data-ath-featured-variant]');
    if (!select) return;
    const price = root.querySelector('[data-ath-price]');
    const compare = root.querySelector('[data-ath-compare]');
    const button = root.querySelector('[data-ath-add]');
    const image = root.querySelector('[data-ath-featured-image]');
    const originalImage = image ? { src: image.src, srcset: image.getAttribute('srcset'), alt: image.alt } : null;
    const sync = () => {
      const selected = select.selectedOptions[0];
      if (!selected) return;
      if (!select.value) {
        button.disabled = true;
        button.querySelector('[data-ath-add-text]').textContent = button.dataset.chooseLabel;
        return;
      }
      const available = selected.dataset.available === 'true';
      price.textContent = selected.dataset.price;
      compare.textContent = selected.dataset.compare || '';
      compare.hidden = !selected.dataset.compare;
      button.disabled = !available;
      button.querySelector('[data-ath-add-text]').textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
      if (image && originalImage) {
        image.src = selected.dataset.image || originalImage.src;
        if (selected.dataset.image) image.removeAttribute('srcset');
        else if (originalImage.srcset) image.setAttribute('srcset', originalImage.srcset);
        image.alt = selected.dataset.image ? selected.dataset.imageAlt : originalImage.alt;
      }
    };
    select.addEventListener('change', sync);
    if (select.value) sync();
  };
  document.querySelectorAll('[data-ath-featured-product]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ath-featured-product]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ath-product-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-ath-recommendations]:not([data-recommendations-ready])').forEach((section) => {
      section.dataset.recommendationsReady = 'true';
      if (section.querySelector('[data-ath-reco-content]')) return;
      const showEditorMessage = (message) => {
        const paragraph = document.createElement('p');
        paragraph.className = 'ath-reco__editor-message';
        paragraph.textContent = message;
        section.replaceChildren(paragraph);
      };
      const load = async () => {
        try {
          const url = new URL(section.dataset.route, window.location.origin);
          url.searchParams.set('section_id', section.dataset.sectionId);
          url.searchParams.set('product_id', section.dataset.productId);
          url.searchParams.set('limit', section.dataset.limit);
          url.searchParams.set('intent', section.dataset.intent);
          const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const rendered = html.getElementById(section.id);
          if (!rendered) throw new Error('Recommendations section was missing from the response');
          if (rendered.querySelector('[data-ath-reco-content]')) section.replaceChildren(...rendered.childNodes);
          else if (window.Shopify?.designMode) showEditorMessage(section.dataset.empty);
          else section.hidden = true;
        } catch (error) {
          if (window.Shopify?.designMode) showEditorMessage(section.dataset.error);
          else section.hidden = true;
          console.warn('ATHCULTURE recommendations:', error);
        }
      };
      if (typeof IntersectionObserver === 'function') {
        const observer = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          load();
        }, { rootMargin: '450px 0px' });
        observer.observe(section);
      } else load();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ath-training-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initLook = (root) => {
    if (!root || root.dataset.athLookReady === 'true') return;
    root.dataset.athLookReady = 'true';
    const selected = new Map();
    const add = root.querySelector('[data-look-add]');
    const status = root.querySelector('[data-look-status]');
    const sync = () => { if (add) add.disabled = selected.size !== 2; };
    root.addEventListener('click', async (event) => {
      const variant = event.target.closest('[data-look-variant]');
      if (variant) {
        const index = variant.dataset.productIndex;
        root.querySelectorAll(`[data-look-variant][data-product-index="${index}"]`).forEach((button) => { button.classList.remove('is-selected'); button.setAttribute('aria-pressed','false'); });
        variant.classList.add('is-selected'); variant.setAttribute('aria-pressed','true');
        selected.set(index, Number(variant.dataset.variantId));
        status?.classList.remove('is-error');
        if (status) status.textContent = selected.size === 2 ? 'Ready to add both pieces.' : 'Choose a size for each piece.';
        sync();
        return;
      }
      if (!event.target.closest('[data-look-add]') || !add || add.disabled) return;
      add.disabled = true;
      root.setAttribute('aria-busy', 'true');
      if (status) { status.textContent = 'Adding both pieces…'; status.classList.remove('is-error'); }
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', credentials: 'same-origin', headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[...selected.values()].map((id) => ({id, quantity:1}))})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add the look.');
        if (status) status.textContent = 'Both pieces added to bag.';
        document.dispatchEvent(new CustomEvent('ath:cart:refresh', { detail: { open: true, opener: add } }));
      } catch (error) {
        if (status) { status.textContent = error.message || 'Could not add the look.'; status.classList.add('is-error'); }
      } finally {
        root.removeAttribute('aria-busy');
        sync();
      }
    });
  };
  document.querySelectorAll('[data-ath-look]').forEach(initLook);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ath-look]').forEach(initLook));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athculture-lab"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-ath-lab-concept]');
  if (!link) return;
  const select = link.closest('.ath-lab')?.querySelector('select[name="contact[concept]"]');
  if (select) select.value = link.dataset.athLabConcept;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (header) => {
    if (header.dataset.athReady) return;
    header.dataset.athReady = 'true';
    const nav = header.querySelector('[data-ath-nav]');
    const menuButton = header.querySelector('[data-ath-menu-button]');
    const search = header.querySelector('[data-ath-search]');
    const input = header.querySelector('[data-ath-search-input]');
    const results = header.querySelector('[data-ath-search-results]');
    const status = header.querySelector('[data-ath-search-status]');
    const heading = header.querySelector('[data-ath-search-heading]');
    const allResults = header.querySelector('[data-ath-search-all]');
    const clearButton = header.querySelector('[data-ath-search-clear]');
    const closeButton = header.querySelector('[data-ath-search-close]');
    const searchForm = search.querySelector('form');
    let timer;
    let request;
    const closeSubmenus = (except) => {
      header.querySelectorAll('[data-ath-submenu-button]').forEach((button) => {
        if (button === except) return;
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', button.dataset.openLabel);
        document.getElementById(button.getAttribute('aria-controls')).hidden = true;
      });
    };
    const closeMenu = () => {
      nav.classList.remove('is-open');
      menuButton.setAttribute('aria-expanded', 'false');
      closeSubmenus();
      document.documentElement.classList.remove('ath-menu-open');
    };
    menuButton.addEventListener('click', () => {
      const opening = menuButton.getAttribute('aria-expanded') !== 'true';
      if (opening) search.open = false;
      nav.classList.toggle('is-open', opening);
      menuButton.setAttribute('aria-expanded', String(opening));
      document.documentElement.classList.toggle('ath-menu-open', opening);
      if (opening) nav.querySelector('a')?.focus();
      else closeSubmenus();
    });
    header.querySelectorAll('[data-ath-submenu-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const opening = button.getAttribute('aria-expanded') !== 'true';
        closeSubmenus(button);
        button.setAttribute('aria-expanded', String(opening));
        button.setAttribute('aria-label', opening ? button.dataset.closeLabel : button.dataset.openLabel);
        document.getElementById(button.getAttribute('aria-controls')).hidden = !opening;
      });
    });
    search.addEventListener('toggle', () => {
      if (search.open) {
        closeMenu();
        input.focus();
        if (input.value.trim().length >= 2) scheduleSuggestions();
      } else {
        clearTimeout(timer);
        request?.abort();
        status.textContent = '';
        status.classList.remove('is-count');
        results.hidden = true;
        heading.hidden = true;
        allResults.hidden = true;
      }
    });
    document.addEventListener('click', (event) => {
      if (header.contains(event.target)) {
        if (event.target.closest('[data-ath-nav] a')) closeMenu();
        return;
      }
      closeMenu();
      search.open = false;
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (search.open) { search.open = false; search.querySelector('summary').focus(); }
      else if (nav.classList.contains('is-open')) { closeMenu(); menuButton.focus(); }
      else closeSubmenus();
    });
    window.addEventListener('resize', () => { if (window.innerWidth > 800) closeMenu(); });
    closeButton.addEventListener('click', () => {
      search.open = false;
      search.querySelector('summary').focus();
    });
    clearButton.addEventListener('click', () => {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    });
    const updateSuggestions = async (query) => {
      request?.abort();
      request = new AbortController();
      status.textContent = search.dataset.searching;
      status.classList.remove('is-count');
      results.replaceChildren();
      results.hidden = true;
      heading.hidden = true;
      const url = new URL(`${search.dataset.suggestUrl}.json`, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', search.dataset.limit);
      url.searchParams.set('resources[options][unavailable_products]', 'hide');
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error(`Search ${response.status}`);
        const payload = await response.json();
        if (input.value.trim() !== query || !search.open) return;
        const products = payload.resources?.results?.products || [];
        status.textContent = products.length ? `${products.length} ${search.dataset.resultsLabel}` : search.dataset.empty;
        status.classList.toggle('is-count', products.length > 0);
        products.forEach((product) => {
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = product.url;
          const imageUrl = product.featured_image?.url;
          const image = document.createElement(imageUrl ? 'img' : 'span');
          image.className = 'ath-header__result-image';
          if (imageUrl) {
            const sizedImage = new URL(imageUrl, window.location.origin);
            sizedImage.searchParams.set('width', '160');
            image.src = sizedImage.toString();
            image.alt = '';
            image.width = 60;
            image.height = 72;
            image.loading = 'lazy';
          } else {
            image.setAttribute('aria-hidden', 'true');
          }
          const copy = document.createElement('span');
          copy.className = 'ath-header__result-copy';
          const title = document.createElement('strong');
          title.textContent = product.title;
          const vendor = document.createElement('small');
          vendor.textContent = product.vendor || '';
          copy.append(title);
          if (product.vendor) copy.append(vendor);
          const price = document.createElement('span');
          price.className = 'ath-header__result-price';
          const amount = Number(product.price);
          if (product.price != null && Number.isFinite(amount)) {
            try {
              const prefix = Number(product.price_min) < Number(product.price_max) ? `${search.dataset.from} ` : '';
              const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: search.dataset.currency }).format(amount);
              price.textContent = `${prefix}${formatted}`;
            } catch {
              price.textContent = `${product.price} ${search.dataset.currency}`;
            }
          }
          link.append(image, copy, price);
          li.append(link);
          results.append(li);
        });
        results.hidden = products.length === 0;
        heading.hidden = products.length === 0;
      } catch (error) {
        if (error.name !== 'AbortError' && input.value.trim() === query && search.open) {
          status.classList.remove('is-count');
          status.textContent = search.dataset.error;
        }
      }
    };
    const scheduleSuggestions = () => {
      clearTimeout(timer);
      request?.abort();
      const query = input.value.trim();
      results.replaceChildren();
      results.hidden = true;
      heading.hidden = true;
      status.textContent = '';
      status.classList.remove('is-count');
      clearButton.hidden = input.value.length === 0;
      allResults.hidden = query.length < 2;
      if (query.length >= 2) {
        const url = new URL(searchForm.action);
        url.searchParams.set('q', query);
        url.searchParams.set('options[prefix]', 'last');
        allResults.href = url.toString();
        timer = setTimeout(() => updateSuggestions(query), 200);
      }
    };
    input.addEventListener('input', scheduleSuggestions);
    input.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown') return;
      const firstLink = results.hidden ? null : results.querySelector('a');
      const target = firstLink || (!allResults.hidden ? allResults : null);
      if (target) { event.preventDefault(); target.focus(); }
    });
    search.querySelector('.ath-header__search-panel').addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const links = [...results.querySelectorAll('a')];
      if (!allResults.hidden) links.push(allResults);
      const index = links.indexOf(document.activeElement);
      if (index < 0) return;
      event.preventDefault();
      if (event.key === 'ArrowUp' && index === 0) input.focus();
      else links[Math.max(0, Math.min(links.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))].focus();
    });
  };
  document.querySelectorAll('[data-ath-header]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ath-header]').forEach(init));
})();

(() => {
  if (window.athCartControllerReady) return;
  window.athCartControllerReady = true;
  let previousFocus = null;
  let previousOverflow = '';
  let busy = false;

  const getDrawer = () => document.querySelector('[data-ath-cart-drawer]');
  const getSectionId = () => document.querySelector('[data-ath-header]')?.dataset.sectionId;
  const getRoot = () => window.Shopify?.routes?.root || '/';
  const cartUrl = () => document.querySelector('[data-ath-cart-open]')?.href || `${getRoot()}cart`;

  const announce = (message, error = false) => {
    const feedback = getDrawer()?.querySelector('[data-ath-cart-feedback]');
    if (!feedback) return;
    feedback.textContent = message;
    feedback.hidden = !message;
    feedback.classList.toggle('is-error', error);
  };

  const openDrawer = (opener) => {
    const drawer = getDrawer();
    if (!drawer) return;
    if (drawer.hidden) {
      const header = document.querySelector('[data-ath-header]');
      const search = header?.querySelector('[data-ath-search]');
      if (search) search.open = false;
      header?.querySelector('[data-ath-nav]')?.classList.remove('is-open');
      header?.querySelector('[data-ath-menu-button]')?.setAttribute('aria-expanded', 'false');
      previousFocus = opener || document.activeElement;
      previousOverflow = document.body.style.overflow;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    drawer.querySelector('.ath-cart__close')?.focus();
  };

  const closeDrawer = () => {
    const drawer = getDrawer();
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.style.overflow = previousOverflow;
    previousFocus?.focus();
  };

  const refreshHtml = async (data) => {
    const sectionId = getSectionId();
    if (!sectionId) throw new Error('Cart section unavailable');
    if (data.sections?.[sectionId]) return data.sections[sectionId];
    const url = new URL(getRoot(), window.location.origin);
    url.searchParams.set('section_id', sectionId);
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart section unavailable');
    return response.text();
  };

  const renderCart = (html) => {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const updatedContent = parsed.querySelector('[data-ath-cart-content]');
    const currentContent = getDrawer()?.querySelector('[data-ath-cart-content]');
    if (!updatedContent || !currentContent) throw new Error('Cart section unavailable');
    currentContent.replaceChildren(...[...updatedContent.childNodes].map((node) => document.importNode(node, true)));
    const count = parsed.querySelector('[data-ath-cart-count]')?.textContent;
    if (count != null) document.querySelectorAll('[data-ath-cart-count]').forEach((node) => { node.textContent = count; });
  };

  const parseResponse = async (response, fallback) => {
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || fallback);
    return data;
  };

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-ath-cart-open]');
    if (opener && getDrawer()) {
      if (window.location.pathname.replace(/\/$/, '') === new URL(opener.href).pathname.replace(/\/$/, '')) return;
      event.preventDefault();
      announce('');
      openDrawer(opener);
      return;
    }
    if (event.target.closest('[data-ath-cart-close]')) {
      closeDrawer();
      return;
    }
    const change = event.target.closest('[data-ath-cart-change]');
    if (!change || busy) return;
    busy = true;
    change.disabled = true;
    announce(change.closest('[data-ath-cart-drawer]')?.dataset.updating || 'Updating bag…');
    let changed = false;
    try {
      const response = await fetch(`${getRoot()}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: change.dataset.key,
          quantity: Number(change.dataset.quantity),
          sections: getSectionId(),
          sections_url: window.location.pathname + window.location.search
        })
      });
      const data = await parseResponse(response, getDrawer()?.dataset.changeError);
      changed = true;
      renderCart(await refreshHtml(data));
      announce(getDrawer()?.dataset.updated || 'Bag updated.');
      if (!getDrawer()?.hidden) getDrawer()?.querySelector('.ath-cart__close')?.focus();
    } catch (error) {
      if (changed) window.location.assign(cartUrl());
      else announce(error.name === 'TypeError' ? getDrawer()?.dataset.changeError : error.message || getDrawer()?.dataset.changeError, true);
    } finally {
      change.disabled = false;
      busy = false;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.submitter?.name !== 'add') return;
    if (!new URL(form.action).pathname.endsWith('/cart/add') || !getDrawer()) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const submitter = event.submitter;
    form.dataset.athSubmitting = 'true';
    form.setAttribute('aria-busy', 'true');
    submitter.disabled = true;
    announce('');
    let added = false;
    try {
      const formData = new FormData(form);
      formData.set('sections', getSectionId());
      formData.set('sections_url', window.location.pathname + window.location.search);
      const response = await fetch(`${getRoot()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: formData
      });
      const data = await parseResponse(response, getDrawer()?.dataset.addError);
      added = true;
      renderCart(await refreshHtml(data));
      openDrawer(submitter);
      announce(getDrawer()?.dataset.added || 'Added to bag.');
    } catch (error) {
      if (added) window.location.assign(cartUrl());
      else {
        openDrawer(submitter);
        announce(error.name === 'TypeError' ? getDrawer()?.dataset.addError : error.message || getDrawer()?.dataset.addError, true);
      }
    } finally {
      delete form.dataset.athSubmitting;
      form.removeAttribute('aria-busy');
      submitter.disabled = false;
      busy = false;
      form.dispatchEvent(new CustomEvent('ath:cart:complete', { bubbles: true }));
    }
  });

  document.addEventListener('ath:cart:refresh', async (event) => {
    if (busy || !getDrawer()) return;
    busy = true;
    try {
      renderCart(await refreshHtml({}));
      if (event.detail?.open !== false) openDrawer(event.detail?.opener || null);
      announce(getDrawer()?.dataset.added || 'Bag updated.');
    } catch (_) {
      window.location.assign(cartUrl());
    } finally {
      busy = false;
    }
  });

  document.addEventListener('keydown', (event) => {
    const drawer = getDrawer();
    if (!drawer || drawer.hidden) return;
    if (event.key === 'Escape') { closeDrawer(); return; }
    if (event.key !== 'Tab') return;
    const controls = [...drawer.querySelectorAll('.ath-cart__panel a[href], .ath-cart__panel button:not([disabled])')].filter((node) => node.getClientRects().length);
    if (!controls.length) return;
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-ath-size-guide-link]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (target instanceof HTMLDetailsElement) target.open = true;
});

  } catch(e) { console.error(e); }
})();
})();
